const originalParents = new WeakMap();
const originalNextSiblings = new WeakMap();

document.addEventListener('click', async function (e) {

  const popupBtn = e.target.closest('.product-form__popup');
  if (popupBtn) {
    const formWrapper = popupBtn.closest('.product-form-wrapper');
    if (!formWrapper) return;
    const modal = formWrapper.querySelector('quick-view-redirection'); 
    if (!modal) return;

    const form = formWrapper.querySelector('form.product-form');
    if (!form) {
      console.error('No product form found to add to cart');
      return;
    }

    e.preventDefault();

    try {
      const formData = new FormData(form);

      const sectionsToBundle = getSectionsToBundle();
      if (sectionsToBundle.length) {
        formData.append('sections', sectionsToBundle.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      });

      if (!response.ok) throw new Error('Add to cart failed');

      const result = await response.json();
      modal._cartSections = result.sections;

      // 🔑 Notifie le thème avec les sections
      if (window.theme?.pubsub?.publish && result.sections) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
          cart: result,
          source: 'product-form'
        });
      }

      if (!originalParents.has(modal)) {
        originalParents.set(modal, modal.parentNode);
        originalNextSiblings.set(modal, modal.nextSibling);
      }

      document.body.appendChild(modal);

      modal.removeAttribute('hidden');
      modal.setAttribute('open', '');
      modal.setAttribute('active', '');
      modal.setAttribute('aria-expanded', 'true');
      document.body.classList.add('has-modal-open');

      modal.querySelector('.overlay')?.classList.remove('pointer-events-none', 'invisible', 'opacity-0');
      modal.querySelector('.drawer__header')?.classList.remove('invisible', 'opacity-0');
      modal.querySelector('.drawer__content')?.classList.remove('invisible', 'opacity-0');

      if (window.theme?.a11y?.trapFocus) {
        const focusElement = modal.querySelector('[is="hover-button"]') || modal;
        window.theme.a11y.trapFocus(modal, focusElement);
      }

      document.dispatchEvent(new CustomEvent('quickview:open', {
        detail: { productUrl: modal.dataset.productUrl }
      }));

    } catch (err) {
      console.error('Add to cart error:', err);
      const errorBox = form.querySelector('.product-form__error-message');
      if (errorBox) {
        errorBox.textContent = 'An unexpected error occurred. Please try again.';
        errorBox.hidden = false;
      }
    }
    return;
  }

  const closeBtn = e.target.closest('quick-view-redirection .button--close');
  if (closeBtn) {
    const modalId = closeBtn.getAttribute('aria-controls');
    const modal = document.getElementById(modalId);
    closeQuickView(modal);
    return;
  }

  const clickedModal = e.target.closest('quick-view-redirection');
  if (clickedModal && clickedModal.hasAttribute('open')) {
    const innerDrawer = clickedModal.querySelector('.drawer__inner');
    if (innerDrawer && !innerDrawer.contains(e.target)) {
      closeQuickView(clickedModal);
      return;
    }
  }

  const redirectBtn = e.target.closest('.product-form__redirection');
  if (redirectBtn) {
    e.preventDefault();
    const redirectUrl = redirectBtn.getAttribute('url');
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
    return;
  }

  // SUBMIT → ferme quickview + ouvre cart drawer rafraichi
  const submitBtn = e.target.closest('.product-form__submit');
  if (submitBtn) {
    e.preventDefault();
    const modal = submitBtn.closest('quick-view-redirection');
    await handleQuickviewExit(modal);
  }

});

function getSectionsToBundle() {
  const sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:bundled-sections', { 
      bubbles: true, 
      detail: { sections: sectionsToBundle } 
    })
  );
  return [...new Set(sectionsToBundle)];
}

window.refreshCartCountOnly = function () {
  return window.fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const countEls = document.querySelectorAll('cart-count, [data-cart-count]');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.setAttribute('aria-label', `${cart.item_count} article${cart.item_count > 1 ? 's' : ''}`);
        if (cart.item_count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', 'true');
        }
      });
      return cart;
    })
    .catch(err => console.error("Error refreshing cart count:", err));
};

async function handleQuickviewExit(modal) {
  if (!modal) return;

  closeQuickViewOnly(modal);
  await refreshCartCountOnly();
  openCartDrawerUI();
}

function closeQuickViewOnly(modal) {
  if (!modal) return;

  modal.removeAttribute('open');
  modal.removeAttribute('active');
  modal.setAttribute('aria-expanded', 'false');
  modal.setAttribute('hidden', 'true');
  document.body.classList.remove('has-modal-open');

  modal.querySelector('.overlay')?.classList.add('pointer-events-none', 'invisible', 'opacity-0');
  modal.querySelector('.drawer__header')?.classList.add('invisible', 'opacity-0');
  modal.querySelector('.drawer__content')?.classList.add('invisible', 'opacity-0');

  const originalParent = originalParents.get(modal);
  const originalNextSibling = originalNextSiblings.get(modal);
  if (originalParent) {
    if (originalNextSibling) {
      originalParent.insertBefore(modal, originalNextSibling);
    } else {
      originalParent.appendChild(modal);
    }
  }
}

function closeQuickView(modal) {
  closeQuickViewOnly(modal);
  refreshCartCountOnly().then(() => openCartDrawerUI());
}

function openCartDrawerUI() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  if (typeof drawer.show === 'function') {
    drawer.show();
  } else {
    document.body.classList.add('has-modal-open');
    drawer.removeAttribute('inert');
    drawer.removeAttribute('hidden');
    drawer.setAttribute('open', '');
    drawer.setAttribute('active', '');
  }
}